// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDependentInfoReducedDto } from './IDependentInfoReducedDto';
import {
    IDependentInfoReducedDtoFromJSON,
    IDependentInfoReducedDtoFromJSONTyped,
    IDependentInfoReducedDtoToJSON,
    IDependentInfoReducedDtoToJSONTyped,
} from './IDependentInfoReducedDto';

/**
 * 
 * @export
 * @interface IPersonSpendLimitDto
 */
export interface IPersonSpendLimitDto {
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    person_spend_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonSpendLimitDto
     */
    total_spent?: number;
    /**
     * 
     * @type {IDependentInfoReducedDto}
     * @memberof IPersonSpendLimitDto
     */
    dependent?: IDependentInfoReducedDto;
}

/**
 * Check if a given object implements the IPersonSpendLimitDto interface.
 */
export function instanceOfIPersonSpendLimitDto(value: object): value is IPersonSpendLimitDto {
    return true;
}

export function IPersonSpendLimitDtoFromJSON(json: any): IPersonSpendLimitDto {
    return IPersonSpendLimitDtoFromJSONTyped(json, false);
}

export function IPersonSpendLimitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPersonSpendLimitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'person_spend_limit': json['person_spend_limit'] == null ? undefined : json['person_spend_limit'],
        'total_spent': json['total_spent'] == null ? undefined : json['total_spent'],
        'dependent': json['dependent'] == null ? undefined : IDependentInfoReducedDtoFromJSON(json['dependent']),
    };
}

export function IPersonSpendLimitDtoToJSON(json: any): IPersonSpendLimitDto {
    return IPersonSpendLimitDtoToJSONTyped(json, false);
}

export function IPersonSpendLimitDtoToJSONTyped(value?: IPersonSpendLimitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'policy_id': value['policy_id'],
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'person_spend_limit': value['person_spend_limit'],
        'total_spent': value['total_spent'],
        'dependent': IDependentInfoReducedDtoToJSON(value['dependent']),
    };
}

